import { useEffect, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { generateReport, getReportById, Report } from '../../../services/report/ReportService';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useReport = (formId?: string, organizationId?: string, reportId?: string) => {
  const [currentFormId, setCurrentFormId] = useState(formId);
  const [currentOrganizationId, setCurrentOrganizationId] = useState(organizationId);
  const [currentReportId, setCurrentReportId] = useState(reportId);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentReport, setCurrentReport] = useState<Report>();

  useEffect(() => {
    if (!currentFormId || !currentOrganizationId) {
      // TODO Set invalid properties
      return;
    }

    setIsLoading(true);
    loadAsync();
  }, [currentFormId, currentOrganizationId]);

  const loadAsync = async () => {
    try {
      if (currentOrganizationId && currentFormId && currentReportId) {
        const { data } = await getReportById(currentOrganizationId, currentFormId, currentReportId);
        setCurrentReport(data);
      }
    } catch (error) {
      handleError(error);
    }
    setIsLoading(false);
  };

  const _generateReport = async (organizationId: string, formId: string, report: Report) => {
    try {
      const { data, headers } = await generateReport(organizationId, formId, report);

      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', headers.filename);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      handleError(error);
    }
  };

  return {
    report: currentReport,
    setFormId: setCurrentFormId,
    setOrganizationId: setCurrentOrganizationId,
    setReportId: setCurrentReportId,
    generateReport: _generateReport,
    isLoading,
  };
};

export default useReport;
